import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";

import AddTechnologyToPortfolio from "@components/Forms/AddTechnologyToPortfolio";
import PageContainer from "@components/PageContainer";
import PageTitle from "@components/PageTitle/PageTitle";
import {
  TableToolbar,
  TableToolbarLeft,
  TableToolbarRight,
  TableToolbarSearch,
  TableToolbarTitle,
} from "@components/TableToolbar/TableToolbar";

import routes from "@constants/routes";

import { useCreateTechnologyFromPortfolio } from "@queries/portfolio.query";

import { OrganizationStore } from "@store/organizationStore";
import { PopupActions } from "@store/popupStore";

import PortfolioTable from "../components/Portfolio/PortfolioTable";

function Portfolio() {
  const [query, setQuery] = useState("");
  const { mutateAsync: createTechnologyFromPortfolio } = useCreateTechnologyFromPortfolio();
  const organization = OrganizationStore.getState().organization;
  const navigate = useNavigate();

  // TODO: gate this using protected routes
  useEffect(() => {
    const organization = OrganizationStore.getState().organization;

    if (organization) {
      console.log("ORGANIZATION", organization);
      navigate(`${routes.ORGANIZATION}/${organization.id}`);
    }
  }, [navigate]); // Only dependencies needed here

  const createTechnologySubmit = async (name: string, description: string) => {
    await createTechnologyFromPortfolio({ description, name });
  };

  const openAddTechnologyModal = () => {
    PopupActions.openModal({
      content: <AddTechnologyToPortfolio createTechnologySubmit={createTechnologySubmit} />,
      title: "Create New Technology",
    });
  };
  return (
    <PageContainer>
      <PageTitle subtitle="Organize companies and contacts by Technology." title="Portfolio" />
      <TableToolbar>
        <TableToolbarLeft>
          <TableToolbarTitle resourceLink="" tableSubtitle="" tableTitle="Technologies" workflow="" />
        </TableToolbarLeft>
        <TableToolbarRight>
          <TableToolbarSearch placeholder="Search Technologies" query={query} setQuery={setQuery} />
          <Button
            color="secondary"
            onClick={openAddTechnologyModal}
            startIcon={<AddCircleIcon />}
            sx={{ borderRadius: "8px", fontColor: "white" }}
            variant="contained"
          >
            New Technology
          </Button>
        </TableToolbarRight>
      </TableToolbar>
      <PortfolioTable isOrganization={false} searchQuery={query} selectedAssignees={[]} />
    </PageContainer>
  );
}

export default Portfolio;
